export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-100">
      <div className="section-container">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 rounded-full text-xs font-medium bg-accent-100 text-accent-700 mb-3">
            随时随地
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            移动端吃瓜入口
          </h2>
        </div>

        <div className="max-w-lg mx-auto">
          <div className="bg-background-50 rounded-2xl p-8 md:p-10 border border-background-200/60 text-center">
            <div className="w-20 h-20 mx-auto mb-6 rounded-2xl bg-primary-50 flex items-center justify-center">
              <i className="ri-smartphone-line text-3xl text-primary-600"></i>
            </div>
            <h3 className="text-xl font-heading font-bold text-foreground-950 mb-3">
              手机端随时吃瓜
            </h3>
            <p className="text-foreground-600 text-sm leading-relaxed mb-6">
              访问吃瓜爆料网手机版，随时随地浏览最新吃瓜爆料网站导航，不错过任何热点。适配各类移动设备，流畅浏览体验。
            </p>
            <a
              href="#index"
              className="inline-flex items-center gap-2 px-5 py-2.5 rounded-lg bg-primary-500 text-background-50 text-sm font-medium whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
            >
              <i className="ri-window-line"></i>
              进入移动版吃瓜导航
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}